export const normalizeTTSMarkdown = (text = "") => {
    if (!text) return "";

    let result = String(text);

    // 移除 AI 输出中的协议码/UI 标记（仅用于触发前端渲染下载按钮/会员卡片/饮食运动记录卡片，
    // 无朗读语义），播报时直接跳过，连带清除其后的空格避免产生停顿
    result = result.replace(
        /@(?:silvervip|goldvip|dietRecord|sportRecord|download)\s*/gi,
        ""
    );

    const replaceStandalone = (pattern, replacement, flags = "gi") => {
        result = result.replace(
            new RegExp(`(?<![A-Za-z0-9_])(?:${pattern})(?![A-Za-z0-9_])`, flags),
            replacement
        );
    };

    const replaceUnit = (pattern, replacement, flags = "gi") => {
        result = result.replace(
            new RegExp(`(\\d+(?:\\.\\d+)?)\\s*(?:${pattern})\\b`, flags),
            `$1${replacement}`
        );
        result = result.replace(
            new RegExp(`(?<![A-Za-z0-9_])(?:${pattern})\\b`, flags),
            replacement
        );
    };

    result = result.replace(/```[\s\S]*?```/g, "");
    result = result.replace(/`([^`]*)`/g, "$1");
    result = result.replace(/<\s*P\s*(\d+(?:\.\d+)?)/gi, "小于P$1");
    result = result.replace(/<\/?[a-z][^>]*>/gi, "");

    result = result.replace(/!\[([^\]]*)\]\([^)]+\)/g, "$1");
    result = result.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");

    result = result.replace(/^#{1,6}\s*/gm, "");
    result = result.replace(/^>\s*/gm, "");
    result = result.replace(/^\s*[-+*]\s+/gm, "");
    result = result.replace(/^\s*\d+[.)、]\s+/gm, "");

    result = result.replace(/\*\*/g, "");
    result = result.replace(/\*/g, "");
    result = result.replace(/__/g, "");
    result = result.replace(/_/g, "");
    result = result.replace(/~~/g, "");

    result = result.replace(
        /^\s*\|?\s*:?-{2,}:?\s*(\|\s*:?-{2,}:?\s*)+\|?\s*$/gm,
        ""
    );

    result = result.replace(/^\s*\|(.+)\|\s*$/gm, (_, row) => {
        const cols = row
            .split("|")
            .map((s) => s.trim())
            .filter(Boolean);

        if (cols.includes("评估项目") || cols.includes("测量值")) {
            return "";
        }

        if (cols.length >= 4) {
            return `${cols[0]}，测量值${cols[1]}，百分位${cols[2]}，解读：${cols[3]}。`;
        }

        return cols.join("，") + "。";
    });

    result = result.replace(/&nbsp;/gi, " ");
    result = result.replace(/&amp;/gi, "和");
    result = result.replace(/&lt;/gi, "小于");
    result = result.replace(/&gt;/gi, "大于");
    result = result.replace(/&quot;/gi, "");
    result = result.replace(/&#39;/gi, "");

    result = result.replace(
        /(?<![A-Za-z0-9_])P\s*(\d+(?:\.\d+)?)\s*(?:～|~|-|—|–|至|到)\s*P\s*(\d+(?:\.\d+)?)(?![A-Za-z0-9_])/gi,
        "P$1到P$2"
    );

    result = result.replace(
        /(?:<|小于)\s*P\s*(\d+(?:\.\d+)?)/gi,
        "小于P$1"
    );

    result = result.replace(
        /(?:>|大于)\s*P\s*(\d+(?:\.\d+)?)/gi,
        "大于P$1"
    );

    result = result.replace(
        /(?:≤|小于等于)\s*P\s*(\d+(?:\.\d+)?)/gi,
        "小于等于P$1"
    );

    result = result.replace(
        /(?:≥|大于等于)\s*P\s*(\d+(?:\.\d+)?)/gi,
        "大于等于P$1"
    );

    result = result.replace(
        /(?<![A-Za-z0-9_])P\s*(\d+(?:\.\d+)?)(?![A-Za-z0-9_])/gi,
        "P$1"
    );

    result = result.replace(/(\d+(?:\.\d+)?)\s*%/g, "百分之$1");
    result = result.replace(/%/g, "百分号");
    result = result.replace(/(\d+(?:\.\d+)?)\s*‰/g, "千分之$1");
    result = result.replace(/‰/g, "千分号");
    result = result.replace(/‱/g, "万分号");

    result = result.replace(/>=\s*/g, "大于等于");
    result = result.replace(/<=\s*/g, "小于等于");
    result = result.replace(/≥/g, "大于等于");
    result = result.replace(/≤/g, "小于等于");
    result = result.replace(/≧/g, "大于等于");
    result = result.replace(/≦/g, "小于等于");
    result = result.replace(/≠/g, "不等于");
    result = result.replace(/≈|≃|≒|≅/g, "约等于");
    result = result.replace(/≡/g, "恒等于");
    result = result.replace(/±/g, "正负");
    result = result.replace(/∓/g, "负正");
    result = result.replace(/×|✕|✖/g, "乘");
    result = result.replace(/÷/g, "除以");
    result = result.replace(/∞/g, "无穷");
    result = result.replace(/√/g, "平方根");
    result = result.replace(/∑/g, "求和");
    result = result.replace(/∫/g, "积分");
    result = result.replace(/°/g, "度");

    result = result.replace(/°\s*C/gi, "摄氏度");
    result = result.replace(/℃/g, "摄氏度");
    result = result.replace(/°\s*F/gi, "华氏度");
    result = result.replace(/℉/g, "华氏度");

    replaceStandalone("BMI\\s*指数", "体质指数");
    replaceStandalone("BMI(?=\\s*值)", "体质指数");
    replaceStandalone("BMI(?=\\s*百分位)", "体质指数");
    replaceStandalone("BMI(?=\\s*(?:for|[-－–—])\\s*age)", "体质指数");
    replaceStandalone("BMI", "体质指数");

    replaceStandalone("SpO\\s*2|SpO₂", "血氧饱和度");
    replaceStandalone("HRV", "心率变异性");
    replaceStandalone("RHR", "静息心率");
    replaceStandalone("VO2\\s*max|VO₂\\s*max", "最大摄氧量");
    replaceStandalone("ECG|EKG", "心电图");
    replaceStandalone("PPG", "光电容积脉搏波");
    replaceStandalone("GPS", "定位");
    replaceStandalone("METs?", "代谢当量");

    replaceStandalone("SDS", "标准差评分");
    replaceStandalone("Z\\s*[-－–—]?\\s*score", "Z评分");
    replaceStandalone("Z分数", "Z评分");
    replaceStandalone("SD\\s*score", "标准差评分");

    replaceStandalone("WHO", "世界卫生组织");
    replaceStandalone("CDC", "疾病控制与预防中心");
    replaceStandalone("AAP", "美国儿科学会");
    replaceStandalone("ESPGHAN", "欧洲儿科胃肠病肝病和营养学会");

    replaceStandalone("HFA", "年龄别身高");
    replaceStandalone("WFA", "年龄别体重");
    replaceStandalone("WFH", "身高别体重");
    replaceStandalone("WFL", "身长别体重");
    replaceStandalone("HAZ", "年龄别身高标准差评分");
    replaceStandalone("WAZ", "年龄别体重标准差评分");
    replaceStandalone("WHZ", "身高别体重标准差评分");
    replaceStandalone("BAZ", "年龄别体质指数标准差评分");
    replaceStandalone("HC|OFC", "头围");
    replaceStandalone("MUAC", "中上臂围");

    replaceStandalone("growth\\s*velocity", "生长速度");
    replaceStandalone("height\\s*velocity", "身高增长速度");
    replaceStandalone("weight\\s*velocity", "体重增长速度");
    replaceStandalone("head\\s*circumference\\s*velocity", "头围增长速度");

    replaceStandalone("BMI\\s*[-－–—]?\\s*for\\s*[-－–—]?\\s*age", "年龄别体质指数");
    replaceStandalone("height\\s*[-－–—]?\\s*for\\s*[-－–—]?\\s*age", "年龄别身高");
    replaceStandalone("length\\s*[-－–—]?\\s*for\\s*[-－–—]?\\s*age", "年龄别身长");
    replaceStandalone("weight\\s*[-－–—]?\\s*for\\s*[-－–—]?\\s*age", "年龄别体重");
    replaceStandalone("weight\\s*[-－–—]?\\s*for\\s*[-－–—]?\\s*height", "身高别体重");
    replaceStandalone("weight\\s*[-－–—]?\\s*for\\s*[-－–—]?\\s*length", "身长别体重");

    replaceStandalone("percentile", "百分位");
    replaceStandalone("growth\\s*chart", "生长曲线");
    replaceStandalone("growth\\s*reference", "生长参考标准");
    replaceStandalone("developmental\\s*milestone", "发育里程碑");
    replaceStandalone("gross\\s*motor", "大运动");
    replaceStandalone("fine\\s*motor", "精细运动");
    replaceStandalone("language\\s*development", "语言发育");
    replaceStandalone("social\\s*development", "社会性发育");
    replaceStandalone("cognitive\\s*development", "认知发育");

    replaceStandalone("overweight", "超重");
    replaceStandalone("obesity", "肥胖");
    replaceStandalone("thinness", "消瘦");
    replaceStandalone("severe\\s*thinness", "重度消瘦");
    replaceStandalone("stunting", "生长迟缓");
    replaceStandalone("wasting", "消瘦");
    replaceStandalone("underweight", "低体重");
    replaceStandalone("malnutrition", "营养不良");
    replaceStandalone("growth\\s*faltering", "生长偏离");
    replaceStandalone("failure\\s*to\\s*thrive|FTT", "生长不良");

    replaceStandalone("HGB|Hb", "血红蛋白");
    replaceStandalone("WBC", "白细胞");
    replaceStandalone("RBC", "红细胞");
    replaceStandalone("PLT", "血小板");
    replaceStandalone("HCT", "红细胞压积");
    replaceStandalone("MCV", "平均红细胞体积");
    replaceStandalone("MCHC", "平均红细胞血红蛋白浓度");
    replaceStandalone("MCH", "平均红细胞血红蛋白含量");
    replaceStandalone("RDW", "红细胞分布宽度");
    replaceStandalone("MPV", "平均血小板体积");
    replaceStandalone("NEUT", "中性粒细胞");
    replaceStandalone("LYM", "淋巴细胞");
    replaceStandalone("MONO", "单核细胞");
    replaceStandalone("EOS", "嗜酸性粒细胞");
    replaceStandalone("BASO", "嗜碱性粒细胞");

    replaceStandalone("ALT", "丙氨酸氨基转移酶");
    replaceStandalone("AST", "天门冬氨酸氨基转移酶");
    replaceStandalone("ALP", "碱性磷酸酶");
    replaceStandalone("GGT", "γ谷氨酰转移酶");
    replaceStandalone("TBIL", "总胆红素");
    replaceStandalone("DBIL", "直接胆红素");
    replaceStandalone("IBIL", "间接胆红素");
    replaceStandalone("TP", "总蛋白");
    replaceStandalone("ALB", "白蛋白");
    replaceStandalone("GLOB", "球蛋白");
    replaceStandalone("A/G", "白蛋白球蛋白比值");

    replaceStandalone("BUN", "尿素氮");
    replaceStandalone("Cr", "肌酐");
    replaceStandalone("eGFR", "估算肾小球滤过率");
    replaceStandalone("Cys-C|CysC", "胱抑素C");
    replaceStandalone("UA", "尿酸");

    replaceStandalone("Glu|GLU", "血糖");
    replaceStandalone("FPG|FBG", "空腹血糖");
    replaceStandalone("OGTT", "口服葡萄糖耐量试验");
    replaceStandalone("HbA1c", "糖化血红蛋白");

    replaceStandalone("TC", "总胆固醇");
    replaceStandalone("TG", "甘油三酯");
    replaceStandalone("HDL-C|HDL", "高密度脂蛋白胆固醇");
    replaceStandalone("LDL-C|LDL", "低密度脂蛋白胆固醇");
    replaceStandalone("VLDL", "极低密度脂蛋白");
    replaceStandalone("ApoA1", "载脂蛋白A1");
    replaceStandalone("ApoB", "载脂蛋白B");
    replaceStandalone("Lp\\(a\\)", "脂蛋白a");

    replaceStandalone("hs-CRP|hsCRP", "超敏C反应蛋白");
    replaceStandalone("CRP", "C反应蛋白");
    replaceStandalone("ESR", "红细胞沉降率");
    replaceStandalone("PCT", "降钙素原");
    replaceStandalone("IL-6", "白细胞介素六");
    replaceStandalone("TNF-α|TNFα", "肿瘤坏死因子α");

    replaceStandalone("TSH", "促甲状腺激素");
    replaceStandalone("FT3", "游离三碘甲状腺原氨酸");
    replaceStandalone("FT4", "游离甲状腺素");
    replaceStandalone("T3", "三碘甲状腺原氨酸");
    replaceStandalone("T4", "甲状腺素");
    replaceStandalone("TPOAb", "甲状腺过氧化物酶抗体");
    replaceStandalone("TGAb", "甲状腺球蛋白抗体");
    replaceStandalone("TRAb", "促甲状腺激素受体抗体");

    replaceStandalone("25\\s*[-－–—]?\\s*OH\\s*[-－–—]?\\s*D|25\\s*\\(OH\\)D", "二十五羟维生素D");
    replaceStandalone("Ferritin", "铁蛋白");
    replaceStandalone("Folate|folic\\s*acid", "叶酸");

    replaceStandalone("HR", "心率");
    replaceStandalone("RR", "呼吸频率");
    replaceStandalone("BP", "血压");
    replaceStandalone("SBP", "收缩压");
    replaceStandalone("DBP", "舒张压");
    replaceStandalone("RHR", "静息心率");
    replaceStandalone("Temp", "体温");
    replaceStandalone("Temperature", "体温");

    replaceStandalone("steps?|step\\s*count", "步数");
    replaceStandalone("distance", "距离");
    replaceStandalone("active\\s*calories", "活动消耗");
    replaceStandalone("calorie\\s*burn", "热量消耗");
    replaceStandalone("active\\s*minutes", "活动时间");
    replaceStandalone("sedentary\\s*time", "久坐时间");
    replaceStandalone("sedentary\\s*behavior", "久坐行为");
    replaceStandalone("sleep\\s*duration", "睡眠时长");
    replaceStandalone("sleep\\s*score", "睡眠评分");
    replaceStandalone("deep\\s*sleep", "深睡眠");
    replaceStandalone("light\\s*sleep", "浅睡眠");
    replaceStandalone("REM\\s*sleep|REM", "快速眼动睡眠");
    replaceStandalone("sleep\\s*latency", "入睡潜伏期");
    replaceStandalone("sleep\\s*efficiency", "睡眠效率");
    replaceStandalone("awake\\s*time", "清醒时间");
    replaceStandalone("screen\\s*time", "屏幕时间");
    replaceStandalone("outdoor\\s*time", "户外活动时间");
    replaceStandalone("water\\s*intake", "饮水量");
    replaceStandalone("fluid\\s*intake", "液体摄入量");
    replaceStandalone("hydration", "水分状态");
    replaceStandalone("appetite", "食欲");
    replaceStandalone("bowel\\s*movement", "排便");
    replaceStandalone("urination", "排尿");
    replaceStandalone("snoring", "打鼾");
    replaceStandalone("stress\\s*level", "压力水平");

    replaceStandalone("physical\\s*activity", "身体活动");
    replaceStandalone("MVPA", "中高强度身体活动");
    replaceStandalone("moderate[-\\s]+to[-\\s]+vigorous\\s+physical\\s+activity", "中高强度身体活动");
    replaceStandalone("exercise\\s*duration", "运动时长");
    replaceStandalone("exercise\\s*intensity", "运动强度");
    replaceStandalone("heart\\s*rate\\s*zone|HR\\s*zone", "心率区间");
    replaceStandalone("warm[-\\s]?up", "热身");
    replaceStandalone("cool[-\\s]?down", "放松");
    replaceStandalone("light\\s*activity", "低强度活动");
    replaceStandalone("moderate\\s*activity", "中等强度活动");
    replaceStandalone("vigorous\\s*activity", "高强度活动");

    replaceStandalone("protein", "蛋白质");
    replaceStandalone("carbohydrate|carbs?", "碳水化合物");
    replaceStandalone("dietary\\s*fiber|fiber", "膳食纤维");
    replaceStandalone("fat", "脂肪");
    replaceStandalone("energy", "能量");
    replaceStandalone("calories?|calorie", "热量");
    replaceStandalone("free\\s*sugar", "游离糖");
    replaceStandalone("added\\s*sugar", "添加糖");
    replaceStandalone("saturated\\s*fat", "饱和脂肪");
    replaceStandalone("trans\\s*fat", "反式脂肪");
    replaceStandalone("unsaturated\\s*fat", "不饱和脂肪");
    replaceStandalone("monounsaturated\\s*fat", "单不饱和脂肪");
    replaceStandalone("polyunsaturated\\s*fat", "多不饱和脂肪");
    replaceStandalone("sodium", "钠");
    replaceStandalone("salt", "盐");

    replaceStandalone("DHA", "二十二碳六烯酸");
    replaceStandalone("EPA", "二十碳五烯酸");
    replaceStandalone("ARA", "花生四烯酸");
    replaceStandalone("ALA", "α亚麻酸");

    replaceStandalone("Vitamin\\s*A|VA", "维生素A");
    replaceStandalone("Vitamin\\s*B1|VB1", "维生素B1");
    replaceStandalone("Vitamin\\s*B2|VB2", "维生素B2");
    replaceStandalone("Vitamin\\s*B6|VB6", "维生素B6");
    replaceStandalone("Vitamin\\s*B12|VB12", "维生素B12");
    replaceStandalone("Vitamin\\s*C|VC", "维生素C");
    replaceStandalone("Vitamin\\s*D|VD", "维生素D");
    replaceStandalone("Vitamin\\s*E|VE", "维生素E");
    replaceStandalone("Vitamin\\s*K|VK", "维生素K");

    replaceStandalone("calcium", "钙");
    replaceStandalone("iron", "铁");
    replaceStandalone("zinc", "锌");
    replaceStandalone("iodine", "碘");
    replaceStandalone("magnesium", "镁");
    replaceStandalone("phosphorus", "磷");
    replaceStandalone("potassium", "钾");
    replaceStandalone("selenium", "硒");
    replaceStandalone("choline", "胆碱");
    replaceStandalone("folate", "叶酸");

    replaceStandalone("qod", "隔日一次");
    replaceStandalone("q4h", "每四小时一次");
    replaceStandalone("q6h", "每六小时一次");
    replaceStandalone("q8h", "每八小时一次");
    replaceStandalone("q12h", "每十二小时一次");
    replaceStandalone("prn", "必要时");
    replaceStandalone("stat", "立即");
    replaceStandalone("ac", "饭前");
    replaceStandalone("pc", "饭后");
    replaceStandalone("po", "口服");
    replaceStandalone("iv", "静脉注射");
    replaceStandalone("im", "肌肉注射");
    replaceStandalone("sc", "皮下注射");
    replaceStandalone("sl", "舌下");
    replaceStandalone("qd", "每天一次");
    replaceStandalone("bid", "每天两次");
    replaceStandalone("tid", "每天三次");
    replaceStandalone("qid", "每天四次");
    replaceStandalone("qn", "每晚一次");
    replaceStandalone("hs", "睡前");

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*g\s*\/\s*kg\s*\/\s*(?:d|day)\b/gi,
        "$1克每千克每天"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mg\s*\/\s*kg\s*\/\s*(?:d|day)\b/gi,
        "$1毫克每千克每天"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*kcal\s*\/\s*kg\s*\/\s*(?:d|day)\b/gi,
        "$1千卡每千克每天"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*(?:mL|ml)\s*\/\s*kg\s*\/\s*(?:d|day)\b/gi,
        "$1毫升每千克每天"
    );

    result = result.replace(
        /(?<![A-Za-z0-9_])g\s*\/\s*kg\s*\/\s*(?:d|day)\b/gi,
        "克每千克每天"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])mg\s*\/\s*kg\s*\/\s*(?:d|day)\b/gi,
        "毫克每千克每天"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])kcal\s*\/\s*kg\s*\/\s*(?:d|day)\b/gi,
        "千卡每千克每天"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])(?:mL|ml)\s*\/\s*kg\s*\/\s*(?:d|day)\b/gi,
        "毫升每千克每天"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mmol\s*\/\s*L\b/gi,
        "$1毫摩尔每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*(?:μmol|µmol|umol)\s*\/\s*L\b/gi,
        "$1微摩尔每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mol\s*\/\s*L\b/gi,
        "$1摩尔每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mg\s*\/\s*dL\b/gi,
        "$1毫克每分升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*g\s*\/\s*L\b/gi,
        "$1克每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mg\s*\/\s*L\b/gi,
        "$1毫克每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*(?:μg|µg|ug|mcg)\s*\/\s*L\b/gi,
        "$1微克每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*IU\s*\/\s*L\b/gi,
        "$1国际单位每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*U\s*\/\s*L\b/gi,
        "$1单位每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mEq\s*\/\s*L\b/gi,
        "$1毫当量每升"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mmHg\b/gi,
        "$1毫米汞柱"
    );
    result = result.replace(
        /(\d+(?:\.\d+)?)\s*cmH2O\b/gi,
        "$1厘米水柱"
    );

    result = result.replace(
        /(?<![A-Za-z0-9_])mmol\s*\/\s*L\b/gi,
        "毫摩尔每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])(?:μmol|µmol|umol)\s*\/\s*L\b/gi,
        "微摩尔每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])mol\s*\/\s*L\b/gi,
        "摩尔每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])mg\s*\/\s*dL\b/gi,
        "毫克每分升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])g\s*\/\s*L\b/gi,
        "克每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])mg\s*\/\s*L\b/gi,
        "毫克每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])(?:μg|µg|ug|mcg)\s*\/\s*L\b/gi,
        "微克每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])IU\s*\/\s*L\b/gi,
        "国际单位每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])U\s*\/\s*L\b/g,
        "单位每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])mEq\s*\/\s*L\b/gi,
        "毫当量每升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])mmHg\b/gi,
        "毫米汞柱"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])cmH2O\b/gi,
        "厘米水柱"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*(?:μg|µg|ug|mcg)\b/gi,
        "$1微克"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])(?:μg|µg|ug|mcg)\b/gi,
        "微克"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*ng\b/gi,
        "$1纳克"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])ng\b/gi,
        "纳克"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*pg\b/gi,
        "$1皮克"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])pg\b/gi,
        "皮克"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mg\b/gi,
        "$1毫克"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])mg\b/gi,
        "毫克"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*kg\b/gi,
        "$1千克"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])kg\b/gi,
        "千克"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*g\b/gi,
        "$1克"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])g\b/gi,
        "克"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*dL\b/gi,
        "$1分升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])dL\b/gi,
        "分升"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*(?:mL|ml)\b/gi,
        "$1毫升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])(?:mL|ml)\b/gi,
        "毫升"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*(?:μL|µL|uL)\b/gi,
        "$1微升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])(?:μL|µL|uL)\b/gi,
        "微升"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*L\b/gi,
        "$1升"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])L\b/g,
        "升"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*mm\b/gi,
        "$1毫米"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])mm\b/gi,
        "毫米"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*cm\b/gi,
        "$1厘米"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])cm\b/gi,
        "厘米"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*m\b/gi,
        "$1米"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])m\b/gi,
        "米"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*kcal\b/gi,
        "$1千卡"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])kcal\b/gi,
        "千卡"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*kJ\b/gi,
        "$1千焦"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])kJ\b/gi,
        "千焦"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*J\b/g,
        "$1焦耳"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])J\b/g,
        "焦耳"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*bpm\b/gi,
        "$1次每分钟"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])bpm\b/gi,
        "次每分钟"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*rpm\b/gi,
        "$1转每分钟"
    );
    result = result.replace(
        /(?<![A-Za-z0-9_])rpm\b/gi,
        "转每分钟"
    );

    result = result.replace(/\/\s*day\b/gi, "每天");
    result = result.replace(/\/\s*d\b/gi, "每天");
    result = result.replace(/\/\s*kg\b/gi, "每千克");
    result = result.replace(/\/\s*min\b/gi, "每分钟");
    result = result.replace(/\/\s*h\b/gi, "每小时");
    result = result.replace(/\/\s*L\b/gi, "每升");

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*(?:～|~|—|–|至)\s*(\d+(?:\.\d+)?)/g,
        "$1到$2"
    );

    result = result.replace(
        /(\d+(?:\.\d+)?)\s*-\s*(\d+(?:\.\d+)?)/g,
        "$1到$2"
    );

    result = result.replace(/≈/g, "约");
    result = result.replace(/→|⇒|➜|➡/g, "到");
    result = result.replace(/←|⇐|⬅/g, "从");
    result = result.replace(/·|⋅/g, "乘");
    result = result.replace(/²/g, "平方");
    result = result.replace(/³/g, "立方");

    result = result.replace(/[|#*_`[\]{}]/g, " ");
    result = result.replace(/[\\/]/g, "每");
    result = result.replace(/[()（）]/g, " ");
    result = result.replace(/-{2,}/g, " ");
    result = result.replace(/\n{2,}/g, "\n");
    result = result.replace(/[ \t]+/g, " ");
    result = result.replace(/\s*([，。！？；：、])\s*/g, "$1");
    result = result.replace(/([，。！？；：])\1+/g, "$1");

    return result.trim();
};